import { useToast } from 'src/hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  ToastIcon,
} from 'src/components/ui/toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({
        id,
        title,
        description,
        message,
        action,
        variant,
        hideIcon,
        ...props
      }) {
        // Combine title, description, and message into a single message
        // Support both new format (message) and old format (title + description) for backward compatibility
        const displayMessage = message || description || title || '';

        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-center gap-3">
              {!hideIcon && variant && <ToastIcon variant={variant} />}
              {displayMessage && <ToastTitle>{displayMessage}</ToastTitle>}
            </div>
            {action}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
